import { useState, type FunctionComponent } from 'react'
import Modal from 'react-modal'
import type { StickyBarResult } from '../data/StickyBarFragment'
import { usePageContext } from '../pages/[[...path]]'
import { Button } from './Button'
import { Container } from './Container'
import { JobsFormModal } from './JobsFormModal'
import s from './BusinessStickyBar.module.sass'
import { useBodyScrollLock } from '../utilities/useBodyScrollLock'
import { useTranslation } from '../utilities/useTranslation'

export type BusinessStickyBarProps = {
	stickyBar?: StickyBarResult | null
}

export const BusinessStickyBar: FunctionComponent<BusinessStickyBarProps> = ({ stickyBar }) => {
	const page = usePageContext()
	const [isModalOpen, setIsModalOpen] = useState(false)
	const jobsForm = stickyBar?.jobsForm ?? page.data.getFooterLocale?.jobsForm ?? null

	const title = useTranslation('businessStickyBar.title', { fallback: 'Zaujali jsme tě? Tak pojďme na to!' })
	const buttonLabel = useTranslation('businessStickyBar.button', { fallback: 'Vyplň formulář' })

	useBodyScrollLock(isModalOpen)

	if (!jobsForm) {
		return null
	}

	return (
		<div className={s.Container}>
			<Container size="wide">
				<div className={s.Wrapper}>
					<p className={s.Title}>{title}</p>
					<Button type="button" onClick={() => setIsModalOpen(true)} variant="red">
						<p className={s.FormButtonLabel}>{buttonLabel}</p>
					</Button>
				</div>
			</Container>

			<Modal
				isOpen={isModalOpen}
				className={s.ModalContent}
				overlayClassName={s.ModalOverlay}
				onRequestClose={() => setIsModalOpen(false)}
			>
				<JobsFormModal jobsFormModal={jobsForm} jobPageIdOverride={null} onRequestClose={() => setIsModalOpen(false)} />
			</Modal>
		</div>
	)
}
